
        var result = require("!!../../../../../node_modules/css-loader/index.js!./services.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/quote-settings/services/services.component.css
// module id = 724
// module chunks = 0